import buildCurrentResidence from './CurrentResidence';
import PreviousResidence from './PreviousResidence';
import SecondPreviousResidence from './SecondPreviousResidence';

const buildResidentialInformationSection = ({ isFinanciallyResponsible }) => ({
  name: 'residentialInformation',
  title: 'Residential Information',
  container: 'default',
  fields: [
    buildCurrentResidence({ isFinanciallyResponsible }),
    ...(isFinanciallyResponsible
      ? [PreviousResidence, SecondPreviousResidence]
      : []),
  ],
});

export default buildResidentialInformationSection;
